import { appPageTransition } from "../common";

(() => {
  if ("undefined" === typeof CURRENT_APP || CURRENT_APP !== "shots") {
    return;
  }

  const CHOICES = {};
  const set = (key, value) => (CHOICES[key] = value);
  const push = (key, value) => CHOICES[key].push(value);

  const numSpirits = $(".shots-spirit").length;

  const setAll = (key) => {
    set(key, []);

    $(`.shots-${key}:checked`).each(function () {
      let value = $(this).attr("id").split("-").pop();

      if (value !== "any") {
        push(key, value);
      }
    });
  };

  // strong
  $("#shots-strong-no").on("click", () => {
    set("strong", false);
    $("#shots-sweet-no").addClass("d-none");
    $("#shots-spirit-absinto-container").addClass("d-none");
    $("#shots-spirit-tequila-container").addClass("d-none");
    appPageTransition("shots-strong", "shots-sweet");
  });

  $("#shots-strong-yes").on("click", () => {
    set("strong", true);
    $("#shots-sweet-champion").addClass("d-none");
    appPageTransition("shots-strong", "shots-sweet");
  });

  $("#shots-strong-champion").on("click", () => {
    set("strong", true);
    appPageTransition("shots-strong", "shots-champion");
  });

  // sweet
  $("#shots-sweet-no").on("click", () => {
    set("sweet", false);
    appPageTransition("shots-sweet", "shots-spirit");
  });

  $("#shots-sweet-yes").on("click", () => {
    set("sweet", true);
    appPageTransition(
      "shots-sweet",
      CHOICES.strong ? "shots-spirit" : "shots-energy"
    );
  });

  $("#shots-sweet-champion").on("click", () => {
    set("sweet", "champion");
    setSuggestion("shots-sweet");
  });

  // energy
  $("#shots-energy-no").on("click", () => {
    set("energy", false);
    appPageTransition("shots-energy", "shots-spirit");
  });

  $("#shots-energy-yes").on("click", () => {
    set("energy", true);
    setSuggestion("shots-energy");
  });

  // spirit
  $(".shots-spirit").on("change", function () {
    if ($(this).attr("id") === "shots-spirit-any" && $(this).prop("checked")) {
      $(".shots-spirit").prop("checked", true);
    } else if ($(".shots-spirit:checked").length < numSpirits) {
      $("#shots-spirit-any").prop("checked", false);
    }

    if ($(".shots-spirit:checked").length === 0) {
      $("#shots-spirit-continue").addClass("d-none");
    } else {
      $("#shots-spirit-continue").removeClass("d-none");
    }
  });

  const PREMIUM_SPIRITS = ["rum", "tequila", "vodka"];

  $("#shots-spirit-continue").on("click", () => {
    setAll("spirit");

    if (
      !CHOICES.sweet &&
      CHOICES.spirit.length === 1 &&
      PREMIUM_SPIRITS.includes(CHOICES.spirit[0])
    ) {
      appPageTransition("shots-spirit", "shots-premium");
    } else {
      setSuggestion("shots-spirit");
    }
  });

  // premium
  $("#shots-premium-no").on("click", () => {
    set("premium", false);
    setSuggestion("shots-premium");
  });

  $("#shots-premium-yes").on("click", () => {
    set("premium", true);
    setSuggestion("shots-premium");
  });

  // champion
  $("#shots-champion-train").on("click", () => {
    set("champion", "train");
    setSuggestion("shots-champion");
  });

  $("#shots-champion-group").on("click", () => {
    set("champion", "group");
    setSuggestion("shots-champion");
  });

  $("#shots-champion-ko").on("click", () => {
    set("champion", "ko");
    setSuggestion("shots-champion");
  });

  $("#shots-champion-final").on("click", () => {
    set("champion", "final");
    setSuggestion("shots-champion");
  });

  // suggestion
  const setSuggestion = (current) => {
    appPageTransition(current, "shots-loading");

    setTimeout(() => {
      fetch(`/mvc/products/actions/search${EXT}?term=shot&alcool=true`)
        .then((response) => response.json())
        .then((shots) => {
          $("#shots-again").removeClass("d-none");

          const allShots = shots.filter(canBeSuggestion);
          let possibleShots = allShots.filter((shot) => shot.featured === "0");
          let featuredShots = allShots.filter((shot) => shot.featured === "1");

          let shot = null;

          if (featuredShots.length > 0) {
            shot = featuredShots.splice(
              Math.floor(Math.random() * featuredShots.length),
              1
            )[0];
          } else if (possibleShots.length > 0) {
            shot = possibleShots.splice(
              Math.floor(Math.random() * possibleShots.length),
              1
            )[0];
          } else {
            // no shot found
            $("#shot-ns-msg").html(noSuggestionMessage());
            appPageTransition("shots-loading", "shots-no-suggestion");
            return;
          }

          $("#shot-img").attr("src", `/img/menu/${shot.image}.png`);
          $("#shot-title").text(shot.title);
          $("#shot-description").text(shot.description);
          $("#shot-price").text(`${shot.price}€`);

          if (featuredShots.length > 0 || possibleShots.length > 0) {
            if (featuredShots.length > 0) {
              shot = featuredShots.splice(
                Math.floor(Math.random() * featuredShots.length),
                1
              )[0];
            } else {
              shot = possibleShots.splice(
                Math.floor(Math.random() * possibleShots.length),
                1
              )[0];
            }

            $("#shot-other-img").attr("src", `/img/menu/${shot.image}.png`);
            $("#shot-other-title").text(shot.title);
            $("#shot-other-description").text(shot.description);
            $("#shot-other-price").text(`${shot.price}€`);

            $("#shots-suggestion-next").removeClass("d-none");
          }

          appPageTransition("shots-loading", "shots-suggestion");
        });
    }, 500);
  };

  $("#shots-suggestion-next").on("click", () =>
    appPageTransition("shots-suggestion", "shots-suggestion-other")
  );

  $("#shots-suggestion-prev").on("click", () =>
    appPageTransition("shots-suggestion-other", "shots-suggestion", {
      out: "right",
      in: "left",
    })
  );

  const noSuggestionMessage = () => {
    const t = {
      true: "sim",
      false: "não",
      train: "treinos",
      group: "grupos",
      ko: "eleminar",
      final: "final",
    };

    let msg = "";

    checkChoice(
      "strong",
      () => (msg += `<br><strong>Forte:</strong>&nbsp;${t[CHOICES.strong]}`)
    );
    checkChoice(
      "sweet",
      () => (msg += `<br><strong>Doce:</strong>&nbsp;${t[CHOICES.sweet]}`)
    );
    checkChoice(
      "energy",
      () => (msg += `<br><strong>Energia:</strong>&nbsp;${t[CHOICES.energy]}`)
    );
    checkChoice(
      "spirit",
      (spirit) =>
        (msg += `<br><strong>Gostos:</strong>&nbsp;${spirit.join(", ")}`)
    );
    checkChoice(
      "premium",
      () => (msg += `<br><strong>Premium:</strong>&nbsp;${t[CHOICES.premium]}`)
    );
    checkChoice(
      "champion",
      () => (msg += `<br><strong>Fase:</strong>&nbsp;${t[CHOICES.champion]}`)
    );

    return msg;
  };

  const SPIRITS = [
    "absinto",
    "absinto 80%",
    "aguardente",
    "bagaço",
    "gin",
    "gold strike",
    "jack daniels",
    "rum",
    "tequila",
    "tequila 100% agave",
    "vodka",
    "vodka branca",
    "whisky",
  ];

  const EXTRAS = ["limão", "sal"];

  const SWEETS = [
    "açúcar",
    "batida de côco",
    "blue coracao",
    "energ",
    "groselha",
    "licor",
    "malibu",
    "maracujá",
    "pisang ambon",
    "triple sec",
    "vodka pink",
    "vodka preta",
  ];

  const SUPER_SWEETS = [
    "advocat",
    "baileys",
    "bubble gum",
    "caramelo",
    "jagermeister",
    "mel",
  ];

  const getSpirits = (shot) => {
    let desc = shot.description.toLowerCase().replaceAll("ç", "c");
    return SPIRITS.filter((s) => desc.includes(s));
  };

  const countIngredients = (shot) => {
    let ingredients = shot.description.toLowerCase().split("+");
    return ingredients
      .map((i) => (EXTRAS.filter((s) => i.includes(s)).length > 0 ? 0 : 1))
      .reduce((acc, count) => acc + count);
  };

  const countSpirits = (shot) => {
    const desc = shot.description.toLowerCase();

    if (
      desc.includes("premium") ||
      desc.includes("vodka /") ||
      desc.includes("rum /") ||
      desc.includes("tequila /") ||
      desc.includes("whisky /")
    ) {
      return 1;
    }

    let ingredients = desc.split("+").map((i) => i.trim());
    return ingredients
      .map((i) => (SPIRITS.filter((s) => i === s).length > 0 ? 1 : 0))
      .reduce((acc, count) => acc + count);
  };

  const countAbsinths = (shot) => {
    let ingredients = shot.description.toLowerCase().split("+");
    return ingredients
      .map(
        (i) =>
          (i.includes("absinto") ? 1 : 0) + (i.includes("absinto 80") ? 1 : 0)
      )
      .reduce((acc, count) => acc + count);
  };

  const countSweets = (shot) => {
    let ingredients = shot.description.toLowerCase().split("+");
    return ingredients
      .map(
        (i) =>
          (SWEETS.filter((s) => i.includes(s)).length > 0 ? 1 : 0) +
          (SUPER_SWEETS.filter((s) => i.includes(s)).length > 0 ? 1.5 : 0)
      )
      .reduce((acc, count) => acc + count);
  };

  const checkChoice = (choice, callback) => {
    if ("undefined" !== typeof CHOICES[choice]) {
      return callback(CHOICES[choice]);
    }

    return false;
  };

  const canBeSuggestion = (shot) => {
    const desc = shot.description.toLowerCase();

    if (desc.includes("premium") !== !!CHOICES.premium) {
      return false;
    }

    if (
      (CHOICES.champion !== undefined || CHOICES.spirit.length !== 1 || CHOICES.spirit[0] !== "tequila") &&
      desc.includes("100%")
    ) {
      return false;
    }

    const ingredients = countIngredients(shot);
    const spirits = countSpirits(shot);

    const spiritsRatio = spirits / ingredients;
    const absinthsRatio = countAbsinths(shot) / ingredients;
    const sweetsRatio = countSweets(shot) / ingredients;

    if (
      checkChoice(
        "strong",
        (strong) =>
          (strong && (spiritsRatio <= 0.5 || spirits > 2 || absinthsRatio > 0.34)) ||
          (!strong && spiritsRatio > 0.5) ||
          (!strong && absinthsRatio > 0)
      )
    ) {
      return false;
    }

    if (
      checkChoice(
        "sweet",
        (sweet) =>
          (sweet === "champion" && sweetsRatio < 1) ||
          (sweet && sweetsRatio <= 0.33) ||
          (!sweet && sweetsRatio > 0.25)
      )
    ) {
      return false;
    }

    if (
      checkChoice(
        "energy",
        (energy) =>
          energy && !desc.includes("energ") ||
          !energy && desc.includes("energ")
        )
    ) {
      return false;
    }

    if (
      checkChoice(
        "spirit",
        (spirit) =>
          !getSpirits(shot)
            .map((s) => spirit.includes(s))
            .includes(true)
      )
    ) {
      return false;
    }

    if (
      checkChoice(
        "champion",
        (champion) =>
          sweetsRatio > 0.34 ||
          (champion === "final" && absinthsRatio <= 0.5) ||
          (champion === "ko" &&
            (absinthsRatio <= 0.34 || absinthsRatio > 0.5)) ||
          (champion === "group" &&
            (absinthsRatio <= 0.125 || absinthsRatio > 0.34 || spirits < 2)) ||
          (champion === "train" &&
            (absinthsRatio > 0.125 || spirits < 1 || spirits > 2))
      )
    ) {
      return false;
    }

    return true;
  };
})();
